"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasuringTooltipContainer = exports.TooltipContainer = exports.Container = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var getTooltipPosition = function (placement) {
    switch (placement) {
        case 'top':
            return "\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-bottom: 6px;\n      ";
        case 'bottom':
            return "\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: 6px;\n      ";
        case 'left':
            return "\n        right: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        margin-right: 6px;\n      ";
        case 'right':
            return "\n        left: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        margin-left: 6px;\n      ";
        default:
            return "\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-bottom: 6px;\n      ";
    }
};
var getArrowPosition = function (placement, theme) {
    switch (placement) {
        case 'top':
            return "\n        top: 100%;\n        left: calc(50% - 6px);\n        border-color: ".concat(theme.colors.bg.dark, " transparent transparent transparent;\n      ");
        case 'bottom':
            return "\n        bottom: 100%;\n        left: calc(50% - 6px);\n        border-color: transparent transparent ".concat(theme.colors.bg.dark, " transparent;\n      ");
        case 'left':
            return "\n        left: 100%;\n        top: calc(50% - 6px);\n        border-color: transparent transparent transparent ".concat(theme.colors.bg.dark, ";\n      ");
        case 'right':
            return "\n        right: 100%;\n        top: calc(50% - 6px);\n        border-color: transparent ".concat(theme.colors.bg.dark, " transparent transparent;\n      ");
        default:
            return "\n        top: 100%;\n        left: calc(50% - 6px);\n        border-color: ".concat(theme.colors.bg.dark, " transparent transparent transparent;\n      ");
    }
};
var getTooltipTransform = function (placement) {
    switch (placement) {
        case 'top':
            return 'translate(-50%, -100%)';
        case 'bottom':
            return 'translate(-50%, 0%)';
        case 'left':
            return 'translate(-100%, -50%)';
        case 'right':
            return 'translate(0%, -50%)';
        default:
            return 'translate(-50%, -100%)';
    }
};
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
// Base tooltip styles shared between both containers
var BaseTooltipContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 4px 6px;\n  border-radius: 6px;\n  text-align: center;\n  z-index: 1000;\n\n  p {\n    color: ", ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    border-width: 6px;\n    border-style: solid;\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  padding: 4px 6px;\n  border-radius: 6px;\n  text-align: center;\n  z-index: 1000;\n\n  p {\n    color: ", ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    border-width: 6px;\n    border-style: solid;\n    ", "\n  }\n"])), function (p) { return p.theme.colors.bg.dark; }, function (p) { return p.theme.colors.text.light; }, function (_a) {
    var placement = _a.placement, theme = _a.theme;
    return getArrowPosition(placement, theme);
});
// For portal-rendered display tooltip
exports.TooltipContainer = (0, styled_components_1.default)(BaseTooltipContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  transform: ", ";\n"], ["\n  position: fixed;\n  transform: ", ";\n"])), function (_a) {
    var placement = _a.placement;
    return getTooltipTransform(placement);
});
// For measuring tooltip with old relative positioning
exports.MeasuringTooltipContainer = (0, styled_components_1.default)(BaseTooltipContainer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n"])), function (_a) {
    var placement = _a.placement;
    return getTooltipPosition(placement);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
